module.exports = "<input style=\"visibility: hidden;\" type=\"file\" name=\"file\" id=\"file\" class=\"inputfile\" (change)=\"onFileChange($event)\" #fileInput>\r\n<input type=\"hidden\" name=\"avatar\" />\r\n<label for=\"file\">\r\n  <div class=\"btn btn-outline-blue btn-big btn-200 btn-avatar mb-1\">{{'DOCUMENTS.ADD-DOC' | translate }}</div>\r\n\r\n  <div class=\"small-text text-center\">{{ 'FORMS.MAXIMUM' | translate }} 5 MB.</div>\r\n</label>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/upload-file-document/upload-file-document.component.html
// module id = ./src/app/shared/components/upload-file-document/upload-file-document.component.html
// module chunks = main